import React from 'react';
import { Mail, Phone, Instagram } from 'lucide-react';

const SocialContact = () => {
  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-amber-50 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Título */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-700 via-blue-500 to-amber-500 bg-clip-text text-transparent">
            ¡Contáctanos!
          </h2>
          <p className="text-gray-700 text-lg md:text-xl">
            Estamos aquí para ayudarte. Escríbenos por cualquier medio
          </p>
        </div>

        {/* Cards de Contacto */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">

          {/* WhatsApp */}
          <a
            href="https://wa.me/51935730575"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-2 border-transparent hover:border-green-500"
          >
            <div className="p-8 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-gradient-to-br from-green-400 to-green-600 rounded-full shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Phone className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3">WhatsApp</h3>
              <p className="text-3xl font-bold text-green-600 mb-4">+51 935 730 575</p>
              <div className="inline-block bg-green-500 text-white px-6 py-3 rounded-full font-semibold group-hover:bg-green-600 transition-colors">
                Escríbenos ahora
              </div>
            </div>
            <div className="h-2 bg-gradient-to-r from-green-400 to-green-600"></div>
          </a>

          {/* Email */}
          <a
            href="mailto:salvapatasperu@gmail.com"
            className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-2 border-transparent hover:border-blue-500"
          >
            <div className="p-8 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Mail className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3">Email</h3>
              <p className="text-xl font-semibold text-blue-600 mb-4 break-all">salvapatasperu@gmail.com</p>
              <div className="inline-block bg-blue-500 text-white px-6 py-3 rounded-full font-semibold group-hover:bg-blue-600 transition-colors">
                Envíanos un correo
              </div>
            </div>
            <div className="h-2 bg-gradient-to-r from-blue-400 to-blue-600"></div>
          </a>

          {/* Instagram */}
          <a
            href="https://instagram.com/salvapatasoficial"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-2 border-transparent hover:border-pink-500"
          >
            <div className="p-8 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500 rounded-full shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Instagram className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3">Instagram</h3>
              <p className="text-2xl font-bold text-transparent bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 bg-clip-text mb-4">
                @salvapatasoficial
              </p>
              <div className="inline-block bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 text-white px-6 py-3 rounded-full font-semibold group-hover:opacity-90 transition-opacity">
                Síguenos
              </div>
            </div>
            <div className="h-2 bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500"></div>
          </a>

        </div>

        {/* Mensaje adicional */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg">
            Responderemos tu mensaje lo más pronto posible
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialContact;
